module.exports = __webpack_public_path__ + "static/media/StrengthMagazineSpread2.172eaf02.jpg";